import React from 'react';

import Placeholder from '../../../Placeholder/Placeholder.jsx';
import SquareBox from '../../../Placeholder/SquareBox.jsx';

export default () => (
  <Placeholder>
    <SquareBox width="24px" height="24px" textAlign="center" margin="3px" />
    <SquareBox width="50%" height="68px" textAlign="center" />
    <SquareBox width="80%" height="63px" textAlign="center" margin="32px 0" />
    <SquareBox width="100%" height="226px" padding="0 30px" />
    <SquareBox width="208px" height="36px" textAlign="right" margin="24px 0 0 0" />
  </Placeholder>
);
